import React, { useEffect, useState } from "react";
import DashboardLayout from "../DashboardLayout";
import UsersList from "./usersList";
import Loading from "../../Components/Loading";
import { fetchUsersList } from "../../services/axios/apiManager";
import { useAppContext } from "../../services/context";
import { handleErrors } from "../../services/dataManager";

const Users = ({ navigate }) => {
  const { state } = useAppContext();
  const { permissions } = state;
  const [users, setUsers] = useState([]);
  const [pagination, setPagination] = useState({});
  const [loading, setLoading] = useState(false);
  const [granted, setGranted] = useState([]);

  const extractPermissions = () => {
    const perms = permissions.filter((f) => f.module === "Users");
    if (perms) {
      setGranted(perms);
    }
  };
  const getData = async () => {
    const res = await fetchUsersList();
    if (res?.data?.success && res?.data?.data) {
      setUsers(res.data.data);
      if (res?.data?.pagination) {
        setPagination(res.data.pagination);
      }
    } else {
      await handleErrors(res, navigate);
    }
    setLoading(false);
  };

  useEffect(() => {
    extractPermissions();
    getData();
  }, []);

  return (
    <DashboardLayout>
      <div
        className="text-light container">
        <div className="row">
          <div className="col-12 mb-3">
            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
              <div className="page-title-right">
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item">
                    <a>Dashboard</a>
                  </li>
                  <li
                    className="breadcrumb-item active"
                    style={{ color: "#d1cdcdbf" }}
                  >
                    users
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        {loading ? (
          <Loading />
        ) : (
          <UsersList
            users={users}
            setUsers={setUsers}
            pagination={pagination}
            setPagination={setPagination}
            granted={granted}
          />
        )}
      </div>
    </DashboardLayout>
  );
};
export default Users;
